export const style = {
  BoxWrapper: {
    sx: {
      marginRight: '6px',
      display: 'flex',
      svg: {
        width: '22px',
        height: '22px',
      },
    },
  },
  Box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1.3,
    },
  },
} as const;
